module.exports = __webpack_public_path__ + "img/weather.4e51b800.jpg";